// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lueJ","label":"styles_label__eo-8e"};